module.exports = __webpack_public_path__ + "static/media/selected.b2410ff1.svg";